(function () {
  "use strict";

  const FETCH_TEMPLATE = "fetch-data";
  const cache = {};

  const getQuery = () => {
    const section = document.querySelector(".search-v2");
    return section ? section.dataset.searchQuery || "" : "";
  };

  const extractResults = (html) => {
    const wrapper = document.createElement("div");
    wrapper.innerHTML = html;

    const cards = wrapper.querySelectorAll(
      ".search-v2-product-list .product-card-default, .search-v2-product-list .v2-article-card"
    );

    const sorted = Array.from(cards).sort((a, b) => {
      const ap = a.hasAttribute("data-priority");
      const bp = b.hasAttribute("data-priority");
      if (ap === bp) return 0;
      return ap ? -1 : 1;
    });

    return { count: sorted.length, html: sorted.map((c) => c.outerHTML).join("") };
  };

  const fetchType = async (type) => {
    if (cache[type]) return cache[type];

    const query = getQuery();
    if (!query) return { count: 0, html: "" };

    const url = `/search?type=${type}&q=${encodeURIComponent(query)}&view=${FETCH_TEMPLATE}`;
    const resp = await fetch(url);
    const text = await resp.text();
    const result = extractResults(text);
    cache[type] = result;
    return result;
  };

  const updateBadge = (type, count) => {
    const badge = document.querySelector(`[data-tab-count="${type}"]`);
    if (!badge) return;
    badge.textContent = count > 0 ? count : "";
    badge.classList.toggle("has-count", count > 0);
  };

  const renderContent = (type, result) => {
    const panel = document.querySelector(`[data-search-tab-content="${type}"]`);
    if (!panel) return;

    if (result.count === 0) {
      panel.innerHTML =
        '<p class="search-v2-tab-empty">該当するコンテンツが見つかりませんでした。</p>';
      return;
    }

    const isArticleType = type === "article" || type === "page";
    const listClass = isArticleType
      ? "search-v2-article-list"
      : "search-v2-product-list";

    panel.innerHTML = `<div class="${listClass}">${result.html}</div>`;
  };

  const rendered = {};

  const switchTab = async (targetType) => {
    document.querySelectorAll(".search-v2-tab").forEach((tab) => {
      const isTarget = tab.dataset.searchTab === targetType;
      tab.classList.toggle("is-active", isTarget);
      tab.setAttribute("aria-selected", isTarget ? "true" : "false");
    });

    document.querySelectorAll(".search-v2-tab-content").forEach((panel) => {
      panel.classList.toggle(
        "is-active",
        panel.dataset.searchTabContent === targetType
      );
    });

    if (targetType === "product") return;

    if (rendered[targetType]) return;

    const panel = document.querySelector(
      `[data-search-tab-content="${targetType}"]`
    );
    if (!panel) return;

    try {
      const result = await fetchType(targetType);
      renderContent(targetType, result);
      updateBadge(targetType, result.count);
      rendered[targetType] = true;
    } catch (e) {
      panel.innerHTML =
        '<p class="search-v2-tab-empty">読み込みに失敗しました。</p>';
    }
  };

  const prefetchCounts = async () => {
    const types = ["article", "page"];
    const results = await Promise.allSettled(types.map((t) => fetchType(t)));

    results.forEach((r, i) => {
      if (r.status === "fulfilled") {
        updateBadge(types[i], r.value.count);
        if (!rendered[types[i]]) {
          renderContent(types[i], r.value);
          rendered[types[i]] = true;
        }
      }
    });
  };

  const init = () => {
    const tabs = document.querySelectorAll(".search-v2-tab");
    if (tabs.length === 0) return;

    tabs.forEach((tab) => {
      tab.addEventListener("click", () => {
        switchTab(tab.dataset.searchTab);
      });
    });

    prefetchCounts();
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
